import { useState } from 'react';
import { Brain, Bot, Sparkles, Cloud, Server } from 'lucide-react';
import ProviderModels from './ProviderModels';

const providers = [
  {
    id: 'openai',
    name: 'OpenAI',
    icon: Brain,
    models: [
      { name: 'GPT-4o', context: '128K tokens', platform: 'OpenAI', inputPrice: '2.50', outputPrice: '10.00' },
      { name: 'GPT-4o mini', context: '128K tokens', platform: 'OpenAI', inputPrice: '0.150', outputPrice: '0.600' },
      { name: 'o1', context: '200K tokens', platform: 'OpenAI', inputPrice: '15.00', outputPrice: '60.00' },
      { name: 'o1-mini', context: '200K tokens', platform: 'OpenAI', inputPrice: '3.00', outputPrice: '12.00' },
      { name: 'o1-preview', context: '200K tokens', platform: 'OpenAI', inputPrice: '15.00', outputPrice: '60.00' }
    ]
  },
  {
    id: 'anthropic',
    name: 'Anthropic',
    icon: Sparkles,
    models: [
      { name: 'claude-3-5-sonnet', context: '200K tokens', platform: 'Anthropic', inputPrice: '3.00', outputPrice: '15.00' },
      { name: 'claude-3-5-haiku', context: '200K tokens', platform: 'Anthropic', inputPrice: '0.80', outputPrice: '4.00' },
      { name: 'claude-3-opus', context: '200K tokens', platform: 'Anthropic', inputPrice: '15.00', outputPrice: '75.00' },
      { name: 'claude-3-sonnet', context: '200K tokens', platform: 'Anthropic', inputPrice: '3.00', outputPrice: '15.00' },
      { name: 'claude-3-haiku', context: '200K tokens', platform: 'Anthropic', inputPrice: '0.25', outputPrice: '1.25' }
    ]
  },
  {
    id: 'google',
    name: 'Google',
    icon: Bot,
    models: [
      { name: 'gemini-1.5-flash', context: '16K tokens', platform: 'Gemini', inputPrice: '--', outputPrice: '--' },
      { name: 'gemini-1.5-flash-8b', context: '16K tokens', platform: 'Gemini', inputPrice: '--', outputPrice: '--' },
      { name: 'gemini-1.5-pro', context: '16K tokens', platform: 'Gemini', inputPrice: '--', outputPrice: '--' },
      { name: 'gemini-2.0-flash-exp', context: '32K tokens', platform: 'Gemini', inputPrice: '--', outputPrice: '--' },
      { name: 'gemini-2.0-flash-thinking-exp', context: '32K tokens', platform: 'Gemini', inputPrice: '--', outputPrice: '--' }
    ]
  },
  {
    id: 'azure',
    name: 'Azure AI',
    icon: Cloud,
    models: [
      { name: 'GPT-4o', context: '128K tokens', platform: 'Azure', inputPrice: '2.50', outputPrice: '10.00' },
      { name: 'GPT-4o mini', context: '128K tokens', platform: 'Azure', inputPrice: '0.150', outputPrice: '0.600' },
      { name: 'o1', context: '200K tokens', platform: 'Azure', inputPrice: '15.00', outputPrice: '60.00' },
      { name: 'o1-mini', context: '200K tokens', platform: 'Azure', inputPrice: '3.00', outputPrice: '12.00' },
      { name: 'o1-preview', context: '200K tokens', platform: 'Azure', inputPrice: '15.00', outputPrice: '60.00' }
    ]
  },
  {
    id: 'aws',
    name: 'Amazon',
    icon: Server,
    models: [
      { name: 'claude-3-5-sonnet', context: '200K tokens', platform: 'Amazon-Anthropic', inputPrice: '3.00', outputPrice: '15.00' },
      { name: 'claude-3-5-haiku', context: '200K tokens', platform: 'Amazon-Anthropic', inputPrice: '0.80', outputPrice: '4.00' },
      { name: 'claude-3-opus', context: '200K tokens', platform: 'Amazon-Anthropic', inputPrice: '15.00', outputPrice: '75.00' },
      { name: 'claude-3-sonnet', context: '200K tokens', platform: 'Amazon-Anthropic', inputPrice: '3.00', outputPrice: '15.00' },
      { name: 'claude-3-haiku', context: '200K tokens', platform: 'Amazon-Anthropic', inputPrice: '0.25', outputPrice: '1.25' }
    ]
  }
];

export default function ProviderTabs() {
  const [activeProvider, setActiveProvider] = useState(providers[0].id);

  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Supported Providers
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Access all major AI providers through a single unified API
          </p>
        </div>

        <div className="mt-12">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex justify-center space-x-8">
              {providers.map((provider) => {
                const Icon = provider.icon;
                return (
                  <button
                    key={provider.id}
                    onClick={() => setActiveProvider(provider.id)}
                    className={`
                      flex items-center pb-4 px-1 border-b-2 font-medium text-sm
                      ${activeProvider === provider.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                    `}
                  >
                    <Icon className="h-5 w-5 mr-2" />
                    {provider.name}
                  </button>
                );
              })}
            </nav>
          </div>

          {providers.map((provider) => (
            <div
              key={provider.id}
              className={activeProvider === provider.id ? 'block' : 'hidden'}
            >
              <ProviderModels models={provider.models} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}